import React, { memo } from "react";
import { Button, TextField, CircularProgress } from "@mui/material";
import { updateVariableByKey } from "redux-store/variableReducers/variableActions";
import { useDispatch, connect } from "react-redux";
import { setIsRefetchEnvironment, setIsRefetchCollection, setIsRefetchFolder } from "redux-store/variableSetReducers/variableSetSlice";
import { useSnackbar } from "contexts/CustomSnackbarContext";

const DialogVariableTooltipComponent = memo(
    ({
        selectedVariable,
        setVariableKey,
        setVariableValue,
        variableKey,
        variableValue,
        environmentName,
        selectedEntity,
        selectedEnvironmentId,
        isResolvingFunction = false
    }) => {
        const dispatch = useDispatch();
        const { openSnackbar } = useSnackbar();
        
        const handleSave = async () => {
            let resourceId = "";
            let resourceType = selectedVariable.type.toLowerCase();
            if (resourceType === "environment") {
                resourceId = selectedEnvironmentId;
            } else if (resourceType === "collection") {
                resourceId = selectedEntity.collection_id;
            } else if (resourceType === "folder") {
                resourceId = selectedEntity.folder_id;
            }
            const response = await dispatch(updateVariableByKey({
                varName: variableKey,
                varValue: variableValue,
                resourceType: resourceType === "environment" ? "variable_set" : resourceType,
                resourceId: resourceId
            }))
            if (response.payload) {
                openSnackbar({ message: `${selectedVariable.type} Variable updated successfully`, severity: 'success' });
                if (resourceType === "environment") {
                    dispatch(setIsRefetchEnvironment(true));
                } else if (resourceType === "collection") {
                    dispatch(setIsRefetchCollection(true));
                } else if (resourceType === "folder") {
                    dispatch(setIsRefetchFolder(true));
                }
            }
        }
        
        return (
            <div
                className="shadow-2xl rounded-xl"
                style={{
                    position: "relative",
                    padding: "16px",
                    minWidth: "250px",
                    backgroundColor: "var(--background-secondary)",
                }}
            >
                <div className="flex items-center justify-between mb-3">
                    <div
                        className={`${selectedVariable.type !== "Unresolved" ? 'text-blue-600' : 'text-red-600'}`}
                        style={{
                            letterSpacing: "0.5px",
                        }}
                    >
                        <span className="uppercase">{selectedVariable.type}</span> 
                        {selectedVariable.type === "Environment" && environmentName && (" - " + environmentName)}
                        {selectedVariable.type === "Functions" && isResolvingFunction && (
                            <span className="ml-2">
                                <CircularProgress size={12} />
                            </span>
                        )}
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                    }}
                >
                    {/* Key Input */}
                    <TextField
                        label="Key"
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={variableKey || ''}
                        onChange={(e) => { setVariableKey(e.target.value) }}
                        style={{ marginBottom: "8px" }}
                        className="disabled:text-gray-900"
                        disabled
                    />
                    {/* Value Input */}
                    <TextField
                        label="Value"
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={isResolvingFunction && selectedVariable.type === "Functions" ? "Resolving..." : (variableValue || '')}
                        onChange={(e) => { setVariableValue(e.target.value) }}
                        style={{ marginBottom: "16px" }}
                        disabled={isResolvingFunction && selectedVariable.type === "Functions"}
                    />
                    {(selectedVariable.type !== "Unresolved" && selectedVariable.type !== "API Variables" && selectedVariable.type !== "Functions") && (
                        <Button variant="contained" color="primary" onClick={() => { handleSave() }}>
                            Save
                        </Button>
                    )}
                </div>
            </div>
        );
    });

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        selectedEnvironmentId: state.variableSet.selectedEnvironmentVariables?.id ?? "",
        selectedEntity: state.user.selectedSidebarState
    }
}

export const DialogVariableTooltip = connect(mapStateToProps)(DialogVariableTooltipComponent);
export default DialogVariableTooltip;